import { services } from "../../../../constants";
import { canUpdateToken, updateUserData, deleteGuestProfile } from "../tokenOperations";
import { phoneVerificationData, geolocation, profiletype, token } from "../../../store";
import { setCookie, getCookieByName } from "../../../../utils/cookiesUtils";
import { setUserLanguage } from "../../../../utils/setLanguage";
import { clearLocalCaches } from "../../media/mediaCacheDecorators";
import { cache } from "../../../persistence/cache";

/**
 * Exposes an object containing the method to run the login service with a given config in
 * order to make the final request to the middleware.
 * @public
 */
const login = {
  async run(config) {
    try {
      const guestProfile = this.guestProfie();
      const userId = guestProfile?.globalUserId || null;

      config = { ...config, ...(userId && { userId: userId }) };

      config?.country && geolocation.update({ country: config.country }); // updating country in sdk store

      const response = await this.http.post(
        `${this.backendHosts.auth}${services.login}`,
        config,
        await this.getHeaders.call(this)
      );
      const spxToken = response && response.data && response.data.spx;
      const jwtToken = response && response.data && response.data.token;
      const profileId = response && response.data && response.data.user && response.data.user.globalUserId;
      // TODO:
      // need to update currentProfile obeject in indexed DB

      response?.data?.user?.profileType && profiletype.update(response?.data?.user?.profileType); // updating profileType im sdk store

      const jwtCookie = this.jwtCookie;
      deleteGuestProfile();
      cache.clear({ database: "auth" });
      setCookie("spx-token", spxToken, jwtCookie.expirationTime);
      setCookie("UID", Date.now());
      token.updateSPXToken.call(this, spxToken);
      response && response.data && response.data.user && setUserLanguage.call(this, response.data.user);
      if (canUpdateToken(response)) {
        updateUserData.call(
          this,
          response.data.token,
          response.data.user.globalUserId,
          config,
          response.data.user.profiles,
          spxToken
        );
      }

      // TO Replicate PUT call after Login
      clearLocalCaches.call(this);

      return response.data.user;
    } catch (error) {
      console.log("==> ~ run ~ error:", error);
      this.handleErrorResponse(error);
    }
  }
};

export default login;
